<template>
  <div class="sql-instanceDatabase-page">
    <Drawer
      title="创建数据库"
      v-model="addDatabaseModal"
      width="500"
      :mask-closable="true"
      @on-close="addDatabaseCancel">
      <div>
        <i-form ref="addDatabaseForm" :model="addDatabaseForm" :label-width="90" :rules="addDatabaseRuleValidate">
          <form-item label="数据库名" prop="db">
            <Input v-model="addDatabaseForm.db" placeholder=""></Input>
          </form-item>
          <form-item>
            <i-button type="primary" @click="handleSubmit">提交</i-button>
            <i-button style="margin-left: 8px" @click="addDatabaseCancel">取消</i-button>
          </form-item>
        </i-form>
      </div>
    </Drawer>
    <Card>
      <Row>
        <i-col span="24">
          <h1>{{this.$route.query.name}}</h1>
          <Divider />
        </i-col>
      </Row>
      <Row>
        <Col span="24" :md="18">
          <Form ref="searchForm" inline :model="searchForm" onsubmit="return false;">
            <FormItem prop="name">
              <i-input clearable placeholder="数据库名" v-model="searchForm.name" style="min-width: 200px;" search
                        @on-enter="getDatabase()"></i-input>
            </FormItem>
            <FormItem :label-width="0" class="mob-align-right">
              <Button type="primary" @click="getDatabase()">搜索</Button>
              <Button @click="searchReset()" style="margin-left: 10px;">重置</Button>
            </FormItem>
          </Form>
        </Col>
        <Col span="24" :md="6" class="align-right">
          <Button @click="addDatabase()" type="primary" :style="{marginBottom: '10px'}" icon="md-add">创建数据库
          </Button>
          <Button @click="refresh()" type="primary" :style="{marginBottom: '10px', marginLeft: '10px'}" icon="md-refresh">刷新</Button>
        </Col>
      </Row>
      <tables ref="instanceDatabaseTable" height="600" search-place="top" v-model="instanceDatabaseData"
              :columns="databaseColumns" />
      <Row style="margin: 10px;">
        <div style="float: right;">
          <page :total="count" :current="page" :page-size="size" @on-change="getDatabase"></page>
        </div>
      </Row>
    </Card>
  </div>
</template>

<script>
import Tables from '_c/tables'
import {getDatabaseList, removeDatabase, addDatabase} from '@/api/sqlserver'

export default {
  name: 'sqlserverInstanceDatabase',
  components: {
    Tables
  },
  data: function () {
    return {
      searchForm: {
        name: ''
      },
      addDatabaseRuleValidate: {
        db: [{required: true, message: '请输入数据库名', trigger: 'blur'}]
      },
      count: 1,
      size: 15,
      page: 1,
      is_superuser: false,
      addDatabaseModal: false,
      addDatabaseForm: {
        id: 0,
        db: ''
      },
      instanceDatabaseData: [],
      databaseColumns: [
        {title: '数据库', key: 'name', align: 'center', minWidth: 170},
        {title: '字符序', key: 'collation_name', align: 'center', minWidth: 160},
        {title: '创建时间',
          key: 'create_date',
          align: 'center',
          minWidth: 170,
          render: (h, params) => {
            return h('div', new Date(params.row.create_date).toLocaleString())
          }
        },
        {
          title: '操作',
          align: 'center',
          minWidth: 80,
          render: (h, params) => {
            if (this.$store.state.user.superuser) {
              return h('div', [
                h('Poptip', {
                  props: {
                    confirm: true,
                    placement: 'bottom',
                    title: '你确定要删除吗?'
                  },
                  on: {
                    'on-ok': () => {
                      this.handleDelete(params.row.name)
                    }
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      size: 'small'
                      // shape: 'circle'
                    },
                    style: {
                      marginRight: '5px'
                    }
                  }, [
                    h('div', '删除')
                  ])
                ])

              ])
            }
          }
        }
      ]
    }
  },
  methods: {
    searchReset () {
      this.searchForm.name = ''
      this.getDatabase()
    },
    refresh () {
      this.getDatabase()
    },
    getDatabase (value = 1) {
      this.page = value
      let params = {
        id: this.$route.query.id,
        page: this.page,
        size: this.size,
        ordering: this.ordering,
        db: this.searchForm.name
      }
      getDatabaseList(params).then(res => {
        this.instanceDatabaseData = res.data.results
        this.count = res.data.count
      }).catch(res => {
        if (res.request) {
          this.$Notice.error({
            title: '获取用户列表失败！请求状态码:' + res.request.status,
            desc: res.request.responseText
          })
        } else {
          this.$Notice.error({
            title: '获取用户列表失败！服务器无响应'
          })
        }
      })
    },

    handleDelete (database) {
      let data = {
        id: this.$route.query.id,
        db: database
      }
      removeDatabase(data).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getDatabase()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },

    editDatabase (params) {
      let data = {
        id: this.$route.query.id,
        db: params.row.SCHEMA_NAME,
        character: params.value
      }
      alterDatabase(data).then(res => {
        this.$Notice.success({title: '操作成功！'})
        this.getDatabase()
      }).catch(res => {
        this.$Notice.error({
          title: '操作失败！ 错误状态码:' + res.request.status,
          desc: res.request.responseText
        })
      })
    },

    addDatabase () {
      this.addDatabaseModal = true
    },

    handleSubmit () {
      this.$refs['addDatabaseForm'].validate((valid) => {
        if (valid) {
          this.addDatabaseForm.id = this.$route.query.id
          addDatabase(this.addDatabaseForm).then(res => {
            this.$Notice.success({title: '操作成功！'})
            this.getDatabase()
            this.addDatabaseCancel()
          }).catch(res => {
            this.$Notice.error({
              title: '操作失败！ 错误状态码:' + res.request.status,
              desc: res.request.responseText
            })
          })
        }
      })
    },

    addDatabaseCancel () {
      this.addDatabaseForm.id = ''
      this.addDatabaseForm.db = ''
      this.addDatabaseModal = false
    }

  },

  mounted: function () {
    this.getDatabase()
  }
}
</script>
<style lang="less">
@media screen and (max-width:640px) {
  .sql-instanceDatabase-page {
    h1 {
      font-size: 1.5em;
    }
    .ivu-divider-horizontal {
      margin: 10px 0 15px;
    }
    .tables-edit-outer .tables-edit-con .tables-edit-btn {
      display: block;
    }
  }
}
</style>
